import React from "react";
import App from "./../app.jsx";
import Login from "../pages/Login.jsx";
import Error from "../pages/error/error.js";
import RegisteredUsers from "../pages/RegisteredUsers/RegisterUsersList.jsx";
import Facility from "../pages/Facility/Facility.jsx";
import AddOrEditFacility from "../pages/Facility/AddOrEditFacility.jsx";
import Document from "../pages/Document/Document.jsx";
import AddorUpdateDocument from "../pages/Document/AddorUpdateDocument.jsx";
import PostalMail from "../pages/PostalMail/PostalMail.jsx";
import { Navigate } from "react-router-dom";
import ManagementUserList from "../pages/ManagementUser/ManagementUserList.jsx";
import AddManagementUser from "../pages/ManagementUser/AddManagementUser.jsx";
import EditManagementUser from "../pages/ManagementUser/EditManagementUser.jsx";
import Dashboard from "../pages/Dashboard/Dashboard.jsx";
import LockDown from "../pages/LockDown.jsx";
import RevenueReport from "../pages/RevenueReport/RevenueReport.jsx";
import PODList from "../pages/POD/PODList.jsx";
import AddPOD from "../pages/POD/AddPOD.jsx";
import KIOSKSList from "../pages/KIOSKS/KIOSKSList.jsx";
import AddKIOSKS from "../pages/KIOSKS/AddKIOSKS.jsx";
import InmateList from "./../pages/Inmates/InmateList";
import PublicUserList from "./../pages/PublicUsers/PublicUserList";
import StaffRequestList from "./../pages/StaffRequest/StaffRequestList";
import PrivateConversation from "./../pages/StaffRequest/PrivateConversation";
import MessageToInmate from "./../pages/StaffRequest/MessageToInmate";
import CreateStaffRequest from "./../pages/StaffRequest/CreateStaffRequest";
import KeywordList from "../pages/Keyword/KeywordList.jsx";
import NoticeList from "../pages/Notice/NoticeList.jsx";
import PaymentReport from "../pages/PaymentReport.jsx";
import TextSearch from "../pages/TextSearchList.jsx";
import ConnectionRequest from "../pages/ConnectionRequest.jsx";
import DNDUserList from "../pages/DND/DNDUserList.jsx";
import AddOrEditDNDUser from "../pages/DND/AddOrEditDNDUser.jsx";
import IPList from "./../pages/IP/IPList";
import IPDetails from "./../pages/IP/IPDetails";
import ChangePassword from "../components/header/dropdown/ChangePassword.jsx";
import AddPostalMail from "../pages/PostalMail/AddPostalMail.jsx";
import Support from "./../components/header/dropdown/support";
import InmateLoginLog from "../pages/POD/InmateLoginLog.jsx";
import ViewPostalMail from "../pages/PostalMail/ViewPostalMail.jsx";
import EditPublicUserInfo from "../pages/RegisteredUsers/EditPublicUserInfo.jsx";
import PhotoInformation from "../pages/Photos/PhotoInformation.jsx";
import PhotoList from "./../pages/Photos/PhotoList";
import MaintenanceSchedules from "../pages/Maintenance/MaintenanceSchedules.jsx";
import Reporting from "../pages/Reporting/Reporting.jsx";
import AddOrEditKeyword from "../pages/Keyword/AddOrEditKeyword.jsx";
import PublicRoute from "../_helpers/PublicRoute.js";
import AuthenticateRouter from "../_helpers/AuthenticateRouter.js";
import FormSearch from "../pages/Reporting/FormSearch.jsx";
import InmateDetails from "../pages/Inmates/InmateDetails.jsx";
import LogReportDetails from "../pages/LogReports/LogReportDetails.jsx";
import AddOrEditNotice from "../pages/Notice/AddOrEditNotice.jsx";
import MessageList from "../pages/Message/MessageList.jsx";
import MessageConversation from "../pages/Message/MessageConversation.jsx";
import VisitorRequestForm from "../pages/StaffRequest/Forms/VisitorRequestForm.jsx";
import LegalResearchRequest from "../pages/StaffRequest/Forms/LegalResearchRequest.jsx";
import RequestRemedyForm from "../pages/StaffRequest/Forms/RequestRemedyForm.jsx";
import RequestFormInfo from "../pages/StaffRequest/Forms/RequestFormInfo.jsx";
import PublicUserAccordion from "../pages/PublicUsers/PublicUserAccordion.jsx";
import PublicDefenderForm from "../pages/StaffRequest/Forms/PublicDefenderForm.jsx";
import PublicDefenderFormCrisp from "../pages/StaffRequest/Forms/PublicDefenderFormCrisp.jsx";
import PrivateConversationRequestForm from "../pages/StaffRequest/Forms/PrivateConversationRequestForm.jsx";
import MessageToInmateRequestForm from "../pages/StaffRequest/Forms/MessageToInmateRequestForm.jsx";
import PublicDefenderRequestForm from "../pages/StaffRequest/Forms/PublicDefenderRequestForm.jsx";
import MaintenancePage from "../pages/MaintenancePage.jsx";
import MultiPhotosApproval from "../pages/Photos/MultiPhotosApproval.jsx";
import EcardList from "../pages/Ecard/EcardList.jsx";
import UploadECard from "../pages/Ecard/UploadECard.jsx";
import ECardCategory from "../pages/Ecard/ECardCategory.jsx";
import AddOrEditECardCategory from "../pages/Ecard/AddOrEditECardCategory.jsx";
import SentECardList from "../pages/Ecard/SentECardList.jsx";
import SentECardDetails from "../pages/Ecard/SentECardDetails.jsx";
import ErrorPage from "../pages/error/ErrorPage.jsx";
import PublicDefenderServiceForm from "../pages/StaffRequest/Forms/PublicDefenderServiceForm.jsx";
import AIPhoto from "../pages/AIPhoto.jsx";
import ConnectionStatus from "../pages/Dashboard/ConnectionInsights.jsx";
import VideoCall from "../pages/AudioAndVideo/VideoCall.jsx";

const AppRoute = [
  {
    path: "/",
    element: <Navigate to="/facilityuser" replace />, // Redirects to login page when accessing root
  },
  {
    path: "/facilityuser",
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },

  {
    path: "/Admin/Maintenance",
    element: <MaintenancePage />,
  },
  {
    path: "/Admin/Error",
    element: <ErrorPage />
  },
  {
    path: "Admin",
    // element: <App />,
    element: (
      <AuthenticateRouter>
        <App />
      </AuthenticateRouter>
    ),
    children: [
      {
        path: "FacilityList",
        element: <Facility />,
      },
      {
        path: "FacilityList/AddEdit",
        element: <AddOrEditFacility />,
      },
      {
        path: "ManagementUserList",
        element: <ManagementUserList />,
      },
      {
        path: "ManagementUserList/Add",
        element: <AddManagementUser />,
      },
      {
        path: "ManagementUserList/Edit",
        element: <EditManagementUser />,
      },
      {
        path: "RegisteredUserList",
        element: <RegisteredUsers />,
      },
      {
        path: "RegisteredUserList/Edit",

        element: <EditPublicUserInfo />,
      },
      {
        path: "Dashboard",
        element: <Dashboard />,
      },
      // {
      //   path: "ConnectionInsights",
      //   element: <ConnectionStatus />,
      // },
      {
        path: "*",
        element: <Error />,
      },
      {
        path: "DocumentList",
        element: <Document />,
      },

      {
        path: "DocumentList/Add",
        element: <AddorUpdateDocument />,
      },

      {
        path: "PostalMailList",
        element: <PostalMail />,
      },
      {
        path: "PostalMailList/Add",
        element: <AddPostalMail />,
      },
      {
        path: "LockdownList",
        element: <LockDown />,
      },
      {
        path: "RevenueReport",
        element: <RevenueReport />,
      },
      {
        path: "PODList",
        element: <PODList />,
      },
      {
        path: "PODList/Add",
        element: <AddPOD />,
      },
      {
        path: "PODList/InmateLoginLog",
        element: <InmateLoginLog />,
      },
      {
        path: "KioskList",
        element: <KIOSKSList />,
      },
      {
        path: "KioskList/Add",
        element: <AddKIOSKS />,
      },
      {
        path: "InmateList",
        element: <InmateList />,
      },
      {
        path: "InmateList/Details",
        element: <InmateDetails />,
      },
      {
        path: "PublicUserList",
        element: <PublicUserList />,
      },
      {
        path: "PublicUserList/Details",
        element: <PublicUserAccordion />,
      },
      {
        path: "StaffRequestList",
        element: <StaffRequestList />,
      },
      {
        path: "StaffRequestList/PrivateConversation",
        element: <PrivateConversation />,
      },
      {
        path: "StaffRequestList/MessageToInmate",
        element: <MessageToInmate />,
      },
      {
        path: "StaffRequestList/Add",
        element: <CreateStaffRequest />,
      },
      {
        path: "StaffRequestList/VisitorRequestForm",
        element: <VisitorRequestForm />,
      },
      {
        path: "StaffRequestList/PrivateConversationRequestForm",
        element: <PrivateConversationRequestForm />,
      },
      {
        path: "StaffRequestList/MessageToInmateRequestForm",
        element: <MessageToInmateRequestForm />,
      },
      {
        path: "StaffRequestList/LegalResearchRequest",
        element: <LegalResearchRequest />,
      },
      {
        path: "StaffRequestList/RequestRemedyForm",
        element: <RequestRemedyForm />,
      },
      {
        path: "StaffRequestList/RequestFormInfo",
        element: <RequestFormInfo />,
      },
      {
        path: "StaffRequestList/PublicDefenderForm",
        element: <PublicDefenderForm />,
      },
      {
        path: "StaffRequestList/PublicDefenderForm/PublicDefenderRequestForm",
        element: <PublicDefenderRequestForm />,
      },
      {
        path: "StaffRequestList/PublicDefenderFormCrisp",
        element: <PublicDefenderFormCrisp />,
      },
      {
        path: "StaffRequestList/PublicDefenderServiceForm",
        element: <PublicDefenderServiceForm />,
      },
      {
        path: "MessageList",
        element: <MessageList />,
      },
      {
        path: "Visitation",
        element: <VideoCall />,
      },
      {
        path: "MessageList/Conversation",
        element: <MessageConversation />,
      },
      {
        path: "KeywordList",
        element: <KeywordList />,
      },
      {
        path: "KeywordList/AddOrEditKeyword",
        element: <AddOrEditKeyword />,
      },
      // {
      //   path: "KeywordList/Edit",
      //   element: <EditKeyword />,
      // },
      {
        path: "NoticeList",
        element: <NoticeList />,
      },
      {
        path: "NoticeList/AddEdit",
        element: <AddOrEditNotice />,
      },
      {
        path: "PaymentReportList",
        element: <PaymentReport />,
      },
      {
        path: "TextSearchList",
        element: <TextSearch />,
      },
      {
        path: "ConnectionRequestList",
        element: <ConnectionRequest />,
      },
      {
        path: "Reporting",
        element: <Reporting />,
      },
      {
        path: "Reporting/Formsearch",
        element: <FormSearch />,
      },

      {
        path: "DNDUserList",
        element: <DNDUserList />,
      },
      {
        path: "PhotoList",
        element: <PhotoList />,
      },
      {
        path: "E-Cards",
        element: <EcardList />,
      },
      {
        path: "E-Cards/Upload",
        element: <UploadECard />,
      },
      {
        path: "E-Cards/Category",
        element: <ECardCategory />,
      },
      {
        path: "E-Cards/Category/AddOrEdit",
        element: <AddOrEditECardCategory />,
      },
      {
        path: "E-Cards/Sent",
        element: <SentECardList />,
      },
      {
        path: "E-Cards/Sent/Details",
        element: <SentECardDetails />,
      },
      {
        path: "DNDUserList/AddEdit",
        element: <AddOrEditDNDUser />,
      },

      {
        path: "LogReports",
        element: <LogReportDetails />,
      },
      {
        path: "MaintenanceSchedules",
        element: <MaintenanceSchedules />,
      },
      {
        path: "IPActivityList",
        element: <IPList />,
      },
      {
        path: "IPActivityList/Details",
        element: <IPDetails />,
      },
      {
        path: "ChangePassword",
        element: <ChangePassword />,
      },
      {
        path: "PostalMailList/View",
        element: <ViewPostalMail />,
      },
      {
        path: "support",
        element: <Support />,
      },
      {
        path: "PhotoList/info",
        element: <PhotoInformation />,
      },
      {
        path: "PhotoList/MultiplePhotosReview",
        element: <MultiPhotosApproval />,
      },
      // {
      //   path: "AIMSGS123",
      //   element: <AIPhoto />,
      // },

      {
        path: "*",
        element: <ErrorPage />,
      },
    ],
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
];

export default AppRoute;
